/* eslint-disable react/no-array-index-key */
import { c } from '../../../utils/tailwind-merge';
import { ProductCardHorizontal } from '../../molecules/Product/ProductCardHorizontal';
import { ProductRowCondensedProps } from './ProductRowCondensed.types';

export const ProductRowCondensed = ({
  microcopy,
  products,
  seeAllLink,
  openInNewTab = false,
  skeletonCount = 4,
  className = '',
}: ProductRowCondensedProps) => {
  const fillCount = skeletonCount ? skeletonCount - products.length : 0;

  return (
    <div
      data-test="product-row-condensed"
      className={c('flex w-full flex-col gap-3', className)}
    >
      <div className="flex justify-between">
        <h2 data-test="product-row-condensed-title" className="header-mid">
          {microcopy.title}
        </h2>
        {seeAllLink && microcopy.seeAll && (
          <a
            href={seeAllLink}
            target={openInNewTab ? '_blank' : undefined}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            data-test="product-row-condensed-see-all"
            className="focus-outline rounded"
          >
            {microcopy.seeAll}
          </a>
        )}
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
        {products.map((product) => (
          <ProductCardHorizontal
            {...product}
            key={product.productId}
            microcopy={microcopy}
            productUrl={`/packages/package/${product.productId}`}
            publisherUrl={`/publishers/${product.publisherId}`}
            openInNewTab={openInNewTab}
          />
        ))}
        {fillCount > 0 &&
          Array.from({ length: fillCount }).map((_, index) => (
            <div
              key={`product-card-horizontal-skeleton-${index}`}
              data-test="product-row-condensed-skeleton"
              className="h-[88px] w-full min-w-[278px] rounded-lg bg-grey-100"
            />
          ))}
      </div>
    </div>
  );
};
